import Vue from 'vue'
import App from './App.vue'
import createRouter from './router'
import createStore from './store'

Vue.config.productionTip = false
import VueMeta from 'vue-meta';
Vue.use(VueMeta);

if(typeof window !== 'undefined'){
  require('sweetalert2/dist/sweetalert2.min.css')
  require('@/js/validation')
}

import {
  ValidationProvider
} from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider);
import {
  Notification
} from 'element-ui';
// import 'sweetalert2/src/sweetalert2.scss'
Vue.prototype.$notify = Notification;
import Swal from 'sweetalert2/dist/sweetalert2.js'
Vue.prototype.$swal = Swal;

import lazyload from 'vue-lazyload';

Vue.use(lazyload, {
  // preLoad: 1.3,
  // lazyloadOnShow: true,
  // lazyloadOnHide: true,
  error: require("./assets/error.svg"),
  loading: require("./assets/loading.gif"),
  // attempt: 1
  try: 2
})

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

export default function createApp(){
  const router = createRouter();
  const store = createStore();
  // console.log('creat vue app');
  const app= new Vue({
    router,
    store,
    render: h => h(App)
  });
  // console.log('creat ok vue app',app);
  return { app,router,store };
}